import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './MiniQuizTestPage.css';

interface TestQuestion {
  id: string;
  imageUrl: string;
  question: string;
  correctAnswer: boolean;
}

const testQuestions: TestQuestion[] = [
  {
    id: '1',
    imageUrl: '/images/bst_kiloba.png',
    question: 'Kiloba có thể bay được không?',
    correctAnswer: true
  },
  {
    id: '2', 
    imageUrl: '/images/bst_kiloba.png',
    question: 'Kiloba thích ăn công nghệ thực phẩm?',
    correctAnswer: true
  },
  {
    id: '3',
    imageUrl: '/images/bst_kiloba.png', 
    question: 'Kiloba có thể phun lửa?',
    correctAnswer: false
  },
  {
    id: '4',
    imageUrl: '/images/bst_kiloba.png',
    question: 'Kiloba có thể nhảy múa?',
    correctAnswer: true
  },
  {
    id: '5',
    imageUrl: '/images/bst_kiloba.png',
    question: 'Kiloba có thể tàng hình?',
    correctAnswer: false
  }
];

const MiniQuizTestPage: React.FC = () => {
  const navigate = useNavigate();
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [score, setScore] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [lastAnswerCorrect, setLastAnswerCorrect] = useState<boolean | null>(null);
  const [gameCompleted, setGameCompleted] = useState(false);

  const currentQuestion = testQuestions[currentQuestionIndex];

  const handleAnswer = (answer: boolean) => {
    const isCorrect = answer === currentQuestion.correctAnswer;
    setLastAnswerCorrect(isCorrect);
    setShowResult(true);

    if (isCorrect) {
      setScore(score + 1);
    }

    // Auto advance after 2 seconds
    setTimeout(() => {
      if (currentQuestionIndex + 1 >= testQuestions.length) {
        setGameCompleted(true);
      } else {
        setCurrentQuestionIndex(currentQuestionIndex + 1);
        setShowResult(false);
        setLastAnswerCorrect(null);
      }
    }, 2000);
  };

  const resetGame = () => {
    setCurrentQuestionIndex(0);
    setScore(0);
    setShowResult(false);
    setLastAnswerCorrect(null);
    setGameCompleted(false);
  };

  if (gameCompleted) {
    return (
      <div className="mini-quiz-page">
        <div className="mini-quiz-header">
          <button className="mini-game-back-btn" onClick={() => navigate(-1)}>
            <img src="/images/icons/back.svg" alt="Back" />
          </button>
          <h1 className="mini-quiz-title">Mini-Quiz (Demo)</h1>
        </div>

        <div className="result-container">
          <div className="completion-result">
            <div className="completion-icon">🎉</div>
            <h2>Hoàn thành!</h2>
            <p className="final-score">Điểm của bạn: {score}/{testQuestions.length}</p>
            <p className="energy-reward">+5 năng lượng</p>
            <button className="play-again-button" onClick={resetGame}>
              Chơi lại
            </button>
            <button className="back-to-menu-button" onClick={() => navigate(-1)}>
              Về menu
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (showResult && lastAnswerCorrect !== null) {
    return (
      <div className="mini-quiz-page">
        <div className="mini-quiz-header">
          <button className="mini-game-back-btn" onClick={() => navigate(-1)}>
            <img src="/images/icons/back.svg" alt="Back" />
          </button>
          <h1 className="mini-quiz-title">Mini-Quiz (Demo)</h1>
        </div>

        <div className="result-container">
          <div className={`result-feedback ${lastAnswerCorrect ? 'correct' : 'incorrect'}`}>
            <div className="result-icon">
              {lastAnswerCorrect ? '✓' : '✗'}
            </div>
            <h2>{lastAnswerCorrect ? 'Chính xác!' : 'Sai rồi!'}</h2>
            <p>Điểm: {score}/{testQuestions.length}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mini-quiz-page">
      <div className="mini-quiz-header">
        <button className="mini-game-back-btn" onClick={() => navigate(-1)}>
          <img src="/images/icons/back.svg" alt="Back" />
        </button>
        <h1 className="mini-quiz-title">Mini-Quiz (Demo)</h1>
      </div>

      <div className="quiz-container">
        <div className="question-progress">
          <span>Câu {currentQuestionIndex + 1}: {score}/{testQuestions.length}</span>
        </div>

        <div className="question-card">
          <div className="question-image">
            <img 
              src={currentQuestion.imageUrl} 
              alt="Question"
              onError={(e) => {
                (e.target as HTMLImageElement).src = '/images/bst_kiloba.png';
              }}
            />
          </div>
          
          <div className="question-content">
            <p className="question-text">{currentQuestion.question}</p>
          </div>
        </div>

        <div className="answer-buttons">
          <button 
            className="answer-button no-button"
            onClick={() => handleAnswer(false)}
          >
            <span className="answer-icon">◀</span>
            <span className="answer-text">No</span>
          </button>
          
          <button 
            className="answer-button yes-button"
            onClick={() => handleAnswer(true)}
          >
            <span className="answer-text">Yes</span>
            <span className="answer-icon">▶</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default MiniQuizTestPage;
